import { render, staticRenderFns } from "./addAgency.vue?vue&type=template&id=5b70a622&scoped=true&"
import script from "./addAgency.vue?vue&type=script&lang=ts&"
export * from "./addAgency.vue?vue&type=script&lang=ts&"
import style0 from "./addAgency.vue?vue&type=style&index=0&id=5b70a622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70a622",
  null
  
)

export default component.exports